import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, CircularProgress, Alert, Button, Box, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import AppNav from '../../../components/appNav';
import { api } from '../../../services/api'

function Programacao() {
    const { eventId } = useParams();
    const navigate = useNavigate();
    const [programacao, setProgramacao] = useState();
    const [evento, setEvento] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        loadProgramacao();
    }, [eventId]);


    async function loadProgramacao() {
        try {
            setLoading(true);
            setError('');

            const eventoResponse = await api.get(`/events/${eventId}`);

            setEvento(eventoResponse.data);
            setProgramacao(eventoResponse.data.scheduling);
        } catch (err) {
            setError('Erro ao carregar programação do evento');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    function handleGoBack() {
        navigate(`/event/${eventId}`);
    }

    function handleDownloadPDF() {
        if (programacao) {
            window.open(programacao, '_blank');
        }
    }

    if (loading) {
        return (
            <Container className="mt-5 text-center">
                <CircularProgress />
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-5">
                <Alert severity="error">{error}</Alert>
                <Button variant="contained" onClick={handleGoBack}>
                    Voltar
                </Button>
            </Container>
        );
    }

    return (
        <>
        <AppNav/>
            <Container sx={{ mt: 4, mb: 4 }}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <Typography variant="h4" component="h2">
                        Programação - {evento?.name || 'Evento'}
                    </Typography>
                    <Button 
                        variant="outlined" 
                        onClick={handleGoBack}
                        sx={{ mt: 2 }}
                    >
                        Voltar
                    </Button>
                </Box>
                <Box>
                    {programacao == undefined ? (
                        <Alert severity="info">
                            Nenhuma programação disponível para este evento.
                        </Alert>
                    ) : (
                        <Box>
                            <Box sx={{ textAlign: 'center', mb: 2 }}>
                                <Button 
                                    variant="contained" 
                                    startIcon={<DownloadIcon />} 
                                    onClick={handleDownloadPDF}
                                >
                                    Baixar Programação (PDF)
                                </Button>
                            </Box>
                                <Box sx={{ 
                                    width: '100%', 
                                    height: '80vh',
                                    border: '1px solid #ddd',
                                    borderRadius: 1,
                                    overflow: 'hidden'
                                }}>
                                    <iframe
                                        src={programacao}
                                        width="100%"
                                        height="100%"
                                        style={{ border: 'none' }}
                                        title="Programação do Evento"
                                    />
                                </Box>
                        </Box>
                    )}
                </Box>
            </Container >
        </>
    );
}

export default Programacao;